import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/laddboxar/")({
  head: () => seoHead("/laddboxar", { description: "Jämför laddboxar och installation för elbilen hemma. Fyll i dina förutsättningar och få kostnadsfria offerter från upp till fyra installatörer." }),
  component: () => <OffertKategori slug="laddboxar" />,
});
